(function () {
  const MOBILE_QUERY = "(max-width: 749px)";

  const initSection = (section) => {
    if (
      !section ||
      !section.classList.contains("features-highlights-section")
    ) {
      return;
    }

    const sliderEl = section.querySelector(".features-highlights-slider");
    if (!sliderEl) return;

    const slidesPerView = Number(sliderEl.dataset.slidesPerView || 4);
    const slidesPerViewMobile = 1.4;
    const slidesPerView576 = 2;
    const slidesPerView750 =
      slidesPerView > 2 ? slidesPerView576 + 1 : slidesPerView576;
    const slidesPerView1160 =
      slidesPerView > 3 ? slidesPerView750 + 1 : slidesPerView750;

    const slides = sliderEl.querySelectorAll(".block-text-with-icon");
    slides.forEach((slide) => {
      slide.classList.add("swiper-slide");
    });

    const updateShadows = (swiper) => {
      if (!swiper || !sliderEl.classList.contains("enable-shadows")) {
        return;
      }

      if (swiper.isBeginning) {
        sliderEl.classList.add("slider-at-start");
      } else {
        sliderEl.classList.remove("slider-at-start");
      }

      if (swiper.isEnd) {
        sliderEl.classList.add("slider-at-end");
      } else {
        sliderEl.classList.remove("slider-at-end");
      }
    };

    const swiperConfig = {
      loop: false,
      spaceBetween: 8,
      speed: 800,
      slidesPerView: slidesPerViewMobile,
      breakpoints: {
        576: {
          spaceBetween: 12,
          slidesPerView: slidesPerView576,
        },
        750: {
          spaceBetween: 12,
          slidesPerView: slidesPerView750,
        },
        990: {
          spaceBetween: 24,
          slidesPerView: slidesPerView750,
        },
        1160: {
          spaceBetween: 24,
          slidesPerView: slidesPerView1160,
        },
        1360: {
          spaceBetween: 32,
          slidesPerView: slidesPerView1160,
        },
      },
      on: {
        init: function () {
          updateShadows(this);
        },
        slideChange: function () {
          updateShadows(this);
        },
        resize: function () {
          updateShadows(this);
        },
      },
    };

    const mobileMarqueeEnabled = sliderEl.dataset.mobileMarquee === "true";
    const wrapper = sliderEl.querySelector(
      ".features-highlights-blocks__wrapper"
    );

    let swiperInstance = null;
    let marqueeActive = false;

    const enableMarquee = () => {
      if (marqueeActive || !wrapper) return;
      sliderEl.classList.add("is-mobile-marquee");
      const originals = Array.from(wrapper.children).filter(
        (child) => child.dataset.marqueeClone !== "true"
      );
      originals.forEach((child) => {
        const clone = child.cloneNode(true);
        clone.setAttribute("aria-hidden", "true");
        clone.dataset.marqueeClone = "true";
        clone.classList.remove("swiper-slide");
        wrapper.appendChild(clone);
      });
      marqueeActive = true;
    };

    const disableMarquee = () => {
      if (!marqueeActive || !wrapper) return;
      sliderEl.classList.remove("is-mobile-marquee");
      wrapper
        .querySelectorAll('[data-marquee-clone="true"]')
        .forEach((el) => el.remove());
      marqueeActive = false;
    };

    const enableSwiper = () => {
      if (swiperInstance) return;
      swiperInstance = new Swiper(sliderEl, swiperConfig);
    };

    const disableSwiper = () => {
      if (!swiperInstance) return;
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    };

    const applyForViewport = (isMobile) => {
      if (mobileMarqueeEnabled && isMobile) {
        disableSwiper();
        enableMarquee();
      } else {
        disableMarquee();
        enableSwiper();
      }
    };

    if (!mobileMarqueeEnabled) {
      enableSwiper();
      return;
    }

    const mql = window.matchMedia(MOBILE_QUERY);
    applyForViewport(mql.matches);

    const handleChange = (event) => applyForViewport(event.matches);
    if (typeof mql.addEventListener === "function") {
      mql.addEventListener("change", handleChange);
    } else if (typeof mql.addListener === "function") {
      mql.addListener(handleChange);
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
